(function () {
  var drawer = document.getElementById('CartDrawer');
  var body = drawer ? drawer.querySelector('[data-cart-drawer-body]') : null;
  var footer = drawer ? drawer.querySelector('[data-cart-drawer-footer]') : null;
  var subtotal = drawer ? drawer.querySelector('[data-cart-subtotal]') : null;

  function updateCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
    });
  }

  function lineHtml(item) {
    var image = item.image ? '<img src="' + item.image + '&width=180" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '';
    return '<div class="cart-line" data-cart-line="' + item.key + '">' +
      '<a class="cart-line__image" href="' + item.url + '">' + image + '</a>' +
      '<div><a class="cart-line__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
      '<p>' + escapeHtml(item.variant_title || '') + '</p>' +
      '<div class="quantity-input"><button type="button" data-cart-qty="' + item.key + '" data-quantity="' + (item.quantity - 1) + '" aria-label="Decrease quantity">-</button><input value="' + item.quantity + '" readonly><button type="button" data-cart-qty="' + item.key + '" data-quantity="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
      '<button class="text-link" type="button" data-cart-qty="' + item.key + '" data-quantity="0">' + window.FabreciaTheme.strings.remove + '</button></div>' +
      '<strong>' + window.Fabrecia.formatMoney(item.final_line_price) + '</strong></div>';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function renderProgress(cart) {
    document.querySelectorAll('[data-cart-progress]').forEach(function (node) {
      var threshold = Number(node.getAttribute('data-threshold') || (window.FabreciaTheme.cart && window.FabreciaTheme.cart.freeShippingThreshold) || 0);
      if (!threshold) {
        node.innerHTML = '';
        return;
      }
      var remaining = threshold - cart.total_price;
      var progress = Math.max(0, Math.min(100, Math.round(cart.total_price / threshold * 100)));
      var message = remaining > 0 ? 'You are ' + window.Fabrecia.formatMoney(remaining) + ' away from free shipping.' : 'Congratulations! You have unlocked free shipping.';
      node.innerHTML = '<span>' + message + '</span><div class="cart-progress__bar"><span style="--progress:' + progress + '%"></span></div>';
    });
  }

  function render(cart) {
    updateCounts(cart.item_count);
    renderProgress(cart);
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty-state"><h3>Your bag is feeling a little light.</h3><p>Explore new drops, bestsellers and accessories.</p><div class="empty-state__actions"><a class="button" href="/pages/men">Shop men</a><a class="button button--secondary" href="/pages/women">Shop women</a></div></div>';
      if (footer) footer.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(lineHtml).join('');
    if (subtotal) subtotal.textContent = window.Fabrecia.formatMoney(cart.total_price);
    if (footer) footer.hidden = false;
  }

  function refresh() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) { return res.json(); }).then(function (cart) {
      render(cart);
      return cart;
    });
  }

  function add(form) {
    var button = form.querySelector('[type="submit"], [data-add-to-cart]');
    if (button) button.setAttribute('aria-busy', 'true');
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return refresh();
    }).then(function () {
      if (window.Fabrecia) window.Fabrecia.openDrawer('CartDrawer', button);
      if (window.Fabrecia && window.Fabrecia.toast) window.Fabrecia.toast('Added to bag');
    }).catch(function (err) {
      if (window.Fabrecia && window.Fabrecia.toast) window.Fabrecia.toast(err.description || window.FabreciaTheme.strings.cartError);
    }).finally(function () {
      if (button) button.removeAttribute('aria-busy');
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    add(form);
  });

  document.addEventListener('click', function (event) {
    var qty = event.target.closest('[data-cart-qty]');
    if (!qty) return;
    event.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: qty.getAttribute('data-cart-qty'), quantity: Number(qty.getAttribute('data-quantity')) })
    }).then(function (res) { return res.json(); }).then(render).catch(function () {
      if (window.Fabrecia && window.Fabrecia.toast) window.Fabrecia.toast(window.FabreciaTheme.strings.cartError);
    });
  });

  var note = drawer ? drawer.querySelector('[data-cart-note]') : null;
  if (note) {
    note.addEventListener('change', function () {
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    });
  }

  window.FabreciaCart = { refresh: refresh, add: add, renderProgress: renderProgress };
  refresh();
})();
